import { menuLinks } from "@/components/header/types/menu.type";
import { create } from "zustand";

type menu = {
  links: menuLinks[];
  showMenu: boolean;
  showCommunity: boolean;

  setMenu: (showStatus: boolean) => void;
  setCommunity: (showStatus: boolean) => void;
  setPages: (pages: menuLinks[]) => void;
};

const useMenu = create<menu>((set) => ({
  showMenu: false,
  showCommunity: false,
  links: [],

  setMenu: (showStatus) => set({ showMenu: showStatus }),

  setCommunity: (showStatus) => set({ showCommunity: showStatus }),

  setPages: (pages) => set({ links: pages }),
}));

export default useMenu;